import React from 'react';
import CountUp, { startAnimation } from 'react-countup';
import Waypoint from 'react-waypoint';
import LazyLoadTransition from '../../components/LazyLoadTransition/LazyLoadTransition';
import './About.scss';

const START_TIME = 0;
const DURATION_TIME = 3;

const stats = {
  days: 3,
  speakers: 39,
  presentations: 22,
  labs: 7,
  attendees: 3600
};

const about = () => {
  let animationStarted = false;
  let days;
  let speakers;
  let presentations;
  let labs;
  let attendees;

  const startCounter = () => {
    if (!animationStarted) {
      startAnimation(days);
      startAnimation(speakers);
      startAnimation(presentations);
      startAnimation(labs);
      startAnimation(attendees);
      animationStarted = true;
    }
  };

  return (
    <>
      {/* <div className="about-background" /> */}
      {/* <div id="note">
        <h1>
          We’re very sorry but the registration to OpenSlava 2022 is currently unavailable. We’re
          working hard to have it fixed as soon as possible. Please come back later.
        </h1>
      </div> */}
      <section className="section" id="about">
        <div className="container">
          <h1>ABOUT</h1>
          <div className="columns is-variable is-desktop is-multiline is-centered is-mobile">
            <div className="column is-6-desktop is-12-tablet is-12-mobile">
              <p>
                OpenSlava 2022 is the 10th edition of a successful annual IT conference focused on
                open source and emerging digital technologies, organized by Accenture in Slovakia.
              </p>
              <div className="as-paragraph">
                OpenSlava 2022 will be organized as 2-day conference:
                <br />
                <strong>
                  <span>Day 1, October 19, 2022: Hand-on labs day</span>
                </strong>
                <ul>
                  <li>
                    Series of 3-hour interactive, deep dive workshops for smaller groups of 20-30
                    participants
                  </li>
                </ul>
                <strong>
                  <span>Day 2, October 20, 2022: Main conference day</span>
                </strong>
                <ul>
                  <li>
                    Keynotes, discussions and presentations centered around the latest tech trends
                    and innovations
                  </li>
                  <li>Exhibition area and networking opportunities</li>
                  <li>
                    Leitmotiv of the conference will be “Uniting Technology and Sustainability”
                  </li>
                </ul>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>OpenSlava 2022: Uniting Technology and Sustainability</span>
                </strong>
                <p>
                  Just as digital transformation required every company to become a technology
                  company, with technology at its heart, now every business needs to become
                  sustainable—and technology is again taking center stage. At OpenSlava 2022 we will
                  look for answers how technology and innovation can play a critical role in
                  supporting company’s transformation to a sustainable organization. Join us and
                  enjoy the presentations, workshops and discussions delivered by top industry
                  speakers. There will be something for every IT enthusiast; cloud, artificial
                  intelligence, security, DevOps UX/UI, quantum computing and much more.
                </p>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>Format of the conference</span>
                </strong>
                <p>
                  We are ready to welcome you in-person once again following the success of the
                  pre-pandemic years. However, your health & safety remains our priority. In case
                  the pandemic situation and/or the public health measures will not allow us to
                  organize the conference on-site, we reserve the right to change the format to
                  solely online or hybrid with a limited number of onsite participants.
                </p>
              </div>
              <div className="as-paragraph">
                <strong>
                  <span>Consider attending OpenSlava 2022 if you are:</span>
                </strong>
                <ul>
                  <li>Technology architect or Developer</li>
                  <li>IT consultant</li>
                  <li>IT student and teachers from IT faculties/universities</li>
                  <li>
                    IT enthusiast interested in innovations, latest trends in open source and
                    emerging digital technologies
                  </li>
                </ul>
              </div>
              <p>
                As we want our OpenSlava community to further grow and keep it open for everyone,
                the registration to the conference will remain <strong>free of charge</strong>.
              </p>
              <p>
                Over the years OpenSlava evolved to an international event attended by{' '}
                <strong>top speakers</strong> and participants from all around the globe, and
                therefore, the <strong>language of the conference is English</strong>.
              </p>
              <p>
                Do you want to learn more about the organizer? Visit{' '}
                <a
                  href="https://www.accenture.com/sk-sk/careers"
                  rel="noopener noreferrer"
                  target="_blank">
                  {' '}
                  www.accenture.sk
                </a>
                .
              </p>
              {/* <p>
                We are hosting inspirational speakers and participants from all around the globe,
                check out the full <a href="https://www.openslava.sk/2021/#/program">program</a>!
              </p> */}
            </div>
            <div className="column is-6-desktop is-12-tablet is-12-mobile" id="youtube-column">
              {/* <LazyLoadTransition> */}
              <div className="card">
                <iframe
                  allowFullScreen
                  frameBorder="0"
                  src="https://www.youtube.com/embed/bIn5K2MLyeM?controls=0"
                  title="yt-video"
                  width="100%"
                />
                <footer className="footer-wrapper">
                  <strong>
                    <p className="card-footer-item">Aftermovie from OpenSlava 2022</p>
                  </strong>
                </footer>
              </div>
              {/* </LazyLoadTransition> */}
            </div>
            <div className="column is-12-desktop is-12-tablet">
              {/* <p className="about-emphasised">
                Day 1, Tuesday - October 19 TECHNOLOGY AND BUSINESS INTERSECTING
              </p>
              <ul>
                <li>Keynotes and discussions oriented towards the future</li>
              </ul>
              <p className="about-emphasised">Day 2, Wednesday - October 20 TECHNOLOGY IN FOCUS</p>
              <ul>
                <li>Lectures and presentations centered around the latest trends</li>
              </ul>
              <p className="about-emphasised">Day 3, Thursday - October 21 SPOTLIGHT ON DIGITAL</p>
              <ul>
                <li>Talks about all things online and interactive</li>
              </ul> */}
              {/* <p>
                The language of the conference is English. OpenSlava ‘21 is expected to follow in
                the footsteps of the successful virtual 2020 edition and take place online.
              </p> */}
            </div>
            {/* <div className="column is-hidden-touch is-6-desktop is-12-tablet" id="youtube-column">
              <LazyLoadTransition>
                <div className="background-layer card">
                  <div className="card-image youtube-wrapper">
                  <iframe
                    allowFullScreen
                    frameBorder="0"
                    src="https://www.youtube.com/embed/Q42OfbMHSFM"
                    title="yt-video"
                    width="100%"
                  />
                  </div>
                  <footer className="footer-wrapper">
                    <strong>
                      <p className="card-footer-item">
                        Marnick Vandebroek invites you to OpenSlava 2021
                      </p>
                    </strong>
                  </footer>
                </div>
              </LazyLoadTransition>
            </div> */}
          </div>

          <LazyLoadTransition>
            <h1 className="section-title openslava-numbers is-hidden-mobile">
              Virtual OpenSlava 2021 in numbers
            </h1>
            <Waypoint onEnter={startCounter} />
            <div className="columns is-variable is-desktop is-mobile is-multiline is-hidden-mobile">
              <div className="column is-2-desktop is-4-tablet is-offset-1-desktop single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      days = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.days}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Days</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      speakers = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.speakers}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Speakers</div>
              </div>
              <div className="column is-2-desktop is-4-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      presentations = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.presentations}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Presentations</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      labs = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.labs}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Hands-on Labs</div>
              </div>
              <div className="column is-2-desktop is-6-tablet single-stat">
                <div className="stat">
                  <CountUp
                    ref={countUp => {
                      attendees = countUp;
                    }}
                    duration={DURATION_TIME}
                    end={stats.attendees}
                    start={START_TIME}
                  />
                </div>
                <div className="stat-info">Unique viewers</div>
              </div>
            </div>
          </LazyLoadTransition>
        </div>
      </section>
    </>
  );
};

export default about;
